import React, { createRef } from "react";
import { createRoot, Root } from "react-dom/client";
import "../scss/base.scss";
import CustomHeader from ".";
import { HeaderProps } from "./types";
import { BUITheme } from "@blofin/blofin-ui";

let headerRoot: Root | null = null;

const createHeader = (props: HeaderProps) => {
  return new Promise<{ updateTheme: (theme: BUITheme) => void } | null>((resolve) => {
    const headerContainer = document.getElementById("header");

    if (headerContainer) {
      if (props.position === "sticky") {
        headerContainer.style.position = props.position;
        headerContainer.style.top = "0px";
        headerContainer.style.zIndex = "1100";
        headerContainer.style.minHeight = "64px";
        headerContainer.style.width = "100%";
      }

      const headerRef = createRef<{ updateTheme: (theme: BUITheme) => void }>();

      if (!headerRoot) {
        headerRoot = createRoot(headerContainer);
      }
      headerRoot.render(
        React.createElement(CustomHeader, {
          ...props,
          ref: headerRef
        })
      );

      const checkRef = () => {
        if (headerRef.current) {
          resolve(headerRef.current);
        } else {
          requestAnimationFrame(checkRef);
        }
      };

      checkRef();
    } else {
      resolve(null);
    }
  });
};

export { createHeader };
